import {IWineShop} from 'modules/wineshops-list/models';
import {createContext} from 'react';

export interface IPickupModalContext {
    isMapButtonShow: boolean;
    mapButtonTitle: string;
    onSelectShop: (wineshop: IWineShop) => any;
    wineShopList: IWineShop[];
    informerText?: string;
}

export const PickupModalContext = createContext<IPickupModalContext>({
    isMapButtonShow: false,
    mapButtonTitle: '',
    onSelectShop: () => {},
    wineShopList: [],
});
